<div class="app-page" style="margin-left: 10px;" fxFill >
  <mat-toolbar style="background-color: var(--mat-sys-background); color: var(--mat-sys-on-background);">
    <button mat-icon-button (click)="back()">
      <mat-icon>
        arrow_back_ios_new
      </mat-icon>
    </button>
    <label>
      {{"PLAYER.PLAYERDETAILS" | translate | uppercase}}
    </label>
    <button matIconButton [matMenuTriggerFor]="menu" style="margin-left: auto;" aria-label="Example icon-button with a menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu" >    
      @if(this.IsFavoritePlayer()) {
        <button  mat-menu-item (click)="removeAsFavorite();">
          <mat-icon>
            star_border
          </mat-icon>
          <span>{{'PLAYER.REMOVEASFAVORITE' | translate | uppercase  }}</span>
        </button>
      }
      @else{
      <button  mat-menu-item (click)="addAsFavorite();">
        <mat-icon>
          star
        </mat-icon>
        <span>{{'PLAYER.ADDASFAVORITE' | translate | uppercase  }}</span>
      </button>
     }
    </mat-menu>
  </mat-toolbar>
  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  <div  style="display: flex; flex-direction: row; flex-wrap: wrap;">
    <div style="align-content: center; text-align: center; margin-right: 20px;">
      <!-- <img src="../../assets/img/icons8-user-shield-48.png" style="height: 48px;"/><br/> -->
      <mat-icon style="font-size: 40px; height: 40px; width: 40px;">account_circle</mat-icon>
      </div>
      <div>
        <span style="font-size: x-large; ">
          @if (this.IsFavoritePlayer()) {
            <mat-icon style="color: orange;">star</mat-icon>
          }
          {{_playerData?.FlowPlayer.LastName}}, {{this._playerData?.FlowPlayer.FirstName }} 
           <img src="../../assets/img/{{this._playerData?.FlowPlayer.Nationality.toLowerCase()}}.png" style="height: 24px; width: 24px;"/>
     
        </span>
        
        <br/>
        <span style="font-size: small; ">
          {{this._playerData?.FlowPlayer.DateOfBirth | date: 'yyy-MM-dd'}}
        </span>
        <span style="font-size: small; ">
              - {{this._playerData?.FlowPlayer.Nationality}} - {{this._playerData?.FlowPlayer.PositionId | position }} - {{this._playerData?.FlowPlayer.Height }} cm - {{this._playerData?.FlowPlayer.ShootId | playerShot }}
        </span>
        
        
      </div>
  </div>
  
  <!-- <div style="margin-left: 60px;">
       <table style="font-size: x-small;">
        <tr>
          <td style="width: 70px;">Age:</td>
          <td>
            {{this._playerData?.PlayerAgeYear }} {{"GENERAL.YEARS"| translate}} {{this._playerData?.PlayerAgeMonth }} {{"GENERAL.MONTHS"| translate}}
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Position:</td>
          <td>{{this._playerData?.FlowPlayer.PositionId | position }}</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>{{"PLAYER.HEIGHT"| translate}}:</td>
          <td>{{this._playerData?.FlowPlayer.Height }} cm</td>
          <td></td>
        </tr>
        <tr>
          <td>{{"PLAYER.WEIGHT"| translate}}:</td>
          <td>{{this._playerData?.FlowPlayer.Weight }} kg</td>
          <td></td>
        </tr>
        <tr>
          <td>{{"PLAYER.SHOOTS"| translate}}:</td>
        
          <td>
            {{this._playerData?.FlowPlayer.ShootId | playerShot }}
          </td>
          <td></td>
        </tr>
        @if (this._playerData?.Module_Tags) {
          <tr>
            <td>{{"PLAYER.TAGS"| translate}}:</td>
            <td>
              <div style="display:flex; flex-direction: column; gap: 6px;">
                <div style="display: flex; flex-wrap: wrap; gap: 4px; align-items: center;">
                  @for (tag of this._playerTags; track tag.TagId) {
                    <div [ngClass]="tag.TagColor" class="player-tag-chip">
                      <span>{{tag.Text || tag.TagText}}</span>
                      <button mat-icon-button aria-label="Remove tag" (click)="removeTag(tag.TagId)" class="player-tag-remove-btn">
                        <mat-icon class="player-tag-remove-icon">close</mat-icon>
                      </button>
                    </div>
                  }
                  @if (this._playerTags.length === 0) {
                    <span style="font-size: 12px; color: gray;">No tags</span>
                  }
                   <button mat-icon-button aria-label="Add tag" (click)="addTag()">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
                <div style="display: flex; align-items: center; gap: 4px;">
                 
                </div>
              </div>
            </td>
            <td>
            </td>
          </tr>
        }

      </table>
  </div>
   -->
  
<mat-tab-group [selectedIndex]="0" mat-stretch-tabs="false" class="scrollable-tabs">
  <!--         <mat-tab label="Overview">

  <div class="hidescrollbars"    style="overflow-y:scroll !important; height: calc(100%-120px) !important;" *ngIf="this._playerData && this._reportmasterdata" >
    <div style="display: flex; flex-direction: column; ">
      <div>
        <span style="">Past games</span>
        <div *ngIf="this._playerData.GamesWithRanking.length==0" class="div_nodata">
          NO DATA
        </div>
        <div style="display: flex; width: 100%; overflow-x: scroll;" class="hidescrollbars" >
          <app-game-card *ngFor="let game of this._playerData.GamesWithRanking.slice(0,6)" [Game]="game" [ShowDate]="true"></app-game-card>
        </div>
      </div>
      <span style="">Coming games</span>
      <div *ngIf="this._playerData.games.length==0" class="div_nodata">
        NO DATA
      </div>
      <div style="display: flex; width: 100%; overflow-x: scroll;" class="hidescrollbars" >

        <app-game-card *ngFor="let game of this._playerData.games.slice(0,6)" [Game]="game" [ShowDate]="true">

        </app-game-card>
      </div>
    </div>
    <span style="">Scouting summary</span>
    <div *ngIf="this._playerData.flowitem.length==0" class="div_nodata">
      NO DATA
    </div>
    <app-player-projection-chart *ngIf="this._playerData.flowitem.length>0"  [PlayerData]="this._playerData" [ReportMasterData]="this._reportmasterdata"></app-player-projection-chart>
  </div>
</mat-tab> -->
@if (this._playerData) {
  <mat-tab  >
    <ng-template mat-tab-label>
      <span [matBadge]="(this._playerData?.flowitem ?? []).length" [matBadgeHidden]="(this._playerData?.flowitem ?? []).length==0" matBadgeOverlap="false">{{"REPORTS.REPORTS"| translate | uppercase}}</span>
    </ng-template>
    @if((this._playerData?.flowitem ?? []).length==0) {
      <div style="margin: auto;color: gray;height: 50px;">
        {{"REPORTS.NOREPORTSORNOTES"| translate | uppercase}}
      </div>
    }
    @if((this._playerData?.flowitem ?? []).length>0 && this._reportmasterdata) {
    <div  class="hidescrollbars" style="overflow-y:scroll !important; height: calc(100%-120px) !important;" >
      <app-chart-player-projection  [PlayerId]="this._playerData?.FlowPlayer.LifelineScoutingId" [Reports]="this._playerData.flowitem" [ProjectionScale]="this._reportmasterdata.Projection"></app-chart-player-projection>
      <div style="display: flex; flex-direction: row; flex-wrap: wrap;">
      @for (item of this._playerData.flowitem; track $index) {
        @if (item.FlowItemType=='SCREPORT') {
          <app-report-card-player [Report]="item" (click)="openReportDetails(item)"></app-report-card-player>
        }
        @if (item.FlowItemType=='PLAYERNOTE') {
          <app-note-card-player [Note]="item"></app-note-card-player>
        }
        
        
      }
    </div>
    </div>  
    }
  </mat-tab>
}
@if (this._playerData) {
  <mat-tab  [disabled]="(this._playerData?.playerplayerlist ?? []).length==0">
    <ng-template mat-tab-label>
      <span [matBadge]="(this._playerData?.playerplayerlist ?? []).length" [matBadgeHidden]="(this._playerData?.playerplayerlist ?? []).length==0" matBadgeOverlap="false">{{"RANKINGLISTS.LISTS"| translate | uppercase}}</span>
    </ng-template>
    <div  class="hidescrollbars ranking-lists-container"     style="overflow-y:scroll !important; height: calc(100%-120px) !important;" >
      @for (list of (this._playerData?.playerplayerlist ?? []); track list.ListId) {
        <app-player-ranking-list-entry [List]="list"></app-player-ranking-list-entry>
      }
      @if ((this._playerData?.playerplayerlist ?? []).length===0) {
        <div style="margin: auto;color: gray;">
          PLAYER IS NOT IN ANY LIST
        </div>
      }
    </div>
  </mat-tab>
}
@if (this._playerData && this._agents && this._contacts) {
  <mat-tab >
    <ng-template mat-tab-label>
      
        <span [matBadge]="this._agents.length + this._contacts.length" [matBadgeHidden]="(this._agents.length + this._contacts.length) ==0" matBadgeOverlap="false" >{{"CONTACTS.CONTACTS"| translate | uppercase}}</span>
      
    </ng-template>
    <div  class="hidescrollbars"     style="overflow-y:scroll !important; height: calc(100%-120px) !important;" >
       <mat-icon> supervisor_account </mat-icon>
      <label>{{"AGENTS.AGENTS"| translate | uppercase}}</label> &nbsp;
    <!--   <button type="button" mat-icon-button (click)="openAddAgentDialog()">
        <mat-icon>add</mat-icon>
        
      </button> -->
      <button type="button" mat-button (click)="openAddAgentDialog()" >{{"AGENTS.ADD_AGENT"| translate | uppercase}}</button>
      <br/>
      <!-- <label>AGENTS</label> &nbsp;<button type="button" mat-button (click)="openAddAgentDialog()">ADD AGENT</button><br/> -->
      <div style="display: flex; flex-direction: row; flex-wrap: wrap;">
        @for (agent of _agents; track agent.Agent.AgentId) {
          <app-agent-card [Agent]="agent" [ConnectedPlayerId]="this._playerId" (AgentRemovedFromPlayer)="this.refreshAgents()"></app-agent-card>
        }
      </div>
      @if (this._agents.length===0) {
        <div style="margin: auto;color: gray;height: 50px;">
          {{"AGENTS.NO_AGENT_INFO"| translate | uppercase}}
        </div>
      }
      <mat-divider></mat-divider>
      <mat-icon>contacts</mat-icon>
      <label>{{"CONTACTS.CONTACTS"| translate | uppercase}}</label> &nbsp; 
      <button type="button" mat-button (click)="openAddContactDialog()" >{{"CONTACTS.ADD_CONTACT"| translate | uppercase}}</button>
      <!-- <label>CONTACTS</label> &nbsp; <button type="button" mat-button (click)="openAddContactDialog()">ADD CONTACT</button> -->
      @if (this._contacts.length===0) {
        <div style="margin: auto;color: gray; height: 50px;">
          {{"CONTACTS.NO_CONTACT_INFO"| translate | uppercase}}
        </div>
      }
      <div style="display: flex; flex-direction: row; flex-wrap: wrap;">
        @for (contact of this._contacts; track contact.ContactId) {
          <app-player-contact-card [Contact]="contact" (ContactUpdated)="refreshContacts();" (ContactDeleted)="refreshContacts();"></app-player-contact-card>
        }
      </div>
      <mat-divider></mat-divider>
    </div>
  </mat-tab>
}


</mat-tab-group>

</div>
